'use client';

import { useState } from 'react';

// Utils
import { combineClasses } from '@shared/utils';

// Components
import { Button, CustomDialog } from '@shared/ui';

// Icons
import DangerIcon from '@shared/icons/DangerIcon';
import { clearLogoutControl } from '@/utils/cookie';
interface ForceLogoutDialogProps {
  open: boolean;
  message: string;
  onClose: () => Promise<void>;
}
export const ForceLogoutDialog = ({
  open,
  message,
  onClose
}: ForceLogoutDialogProps) => {
  const [isClosing, setIsClosing] = useState(false);
  const handleClose = async () => {
    setIsClosing(true);
    clearLogoutControl();

    // Wait for the user to be logged out
    await onClose();
    setIsClosing(false);
  };
  if (!message) return null;
  return <CustomDialog open={open} onOpenChange={handleClose} className={combineClasses('sm:max-w-sm active:ring-0 p-3.5', 'focus:outline-0 focus-visible:outline-0 focus-within:outline-0')} data-sentry-element="CustomDialog" data-sentry-component="ForceLogoutDialog" data-sentry-source-file="index.tsx">
      <div className="flex flex-col items-center">
        {/* Icon */}
        <div className={combineClasses('flex-center rounded-full', 'size-16 bg-red-100')}>
          <DangerIcon className="size-8 text-destructive" data-sentry-element="DangerIcon" data-sentry-source-file="index.tsx" />
        </div>

        {/* Message */}
        <div className="text-center space-y-2 my-3">
          <p className="text-gray-600 text-xs leading-relaxed whitespace-pre-line text-balance">
            {message}
          </p>
        </div>

        {/* Button */}
        <Button aria-label="Close and logout" isLoading={isClosing} className={combineClasses('w-full bg-red-600 hover:bg-red-700', 'text-white font-medium py-2.5', 'transition-colors focus-visible:ring-0')} onClick={handleClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          Continue
        </Button>
      </div>
    </CustomDialog>;
};